export default "__VITE_PUBLIC_ASSET__86c15343__"